var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "wrapper"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "slick-wrap"
  }, [_c('slick', {
    ref: "slick",
    attrs: {
      "options": _vm.slickOptions,
      "dir": "rtl"
    }
  }, [_c('div', {
    attrs: {
      "data-slide": ""
    }
  }, [_c('img', {
    attrs: {
      "src": require("../assets/comic/001/p01.jpg"),
      "alt": ""
    }
  })]), _vm._v(" "), _c('div', {
    attrs: {
      "data-slide": ""
    }
  }, [_c('img', {
    attrs: {
      "src": require("../assets/comic/001/p02.jpg"),
      "alt": ""
    }
  })]), _vm._v(" "), _c('div', {
    attrs: {
      "data-slide": ""
    }
  }, [_c('img', {
    attrs: {
      "src": require("../assets/comic/001/p03.jpg"),
      "alt": ""
    }
  })]), _vm._v(" "), _c('div', {
    attrs: {
      "data-slide": ""
    }
  }, [_c('img', {
    attrs: {
      "src": require("../assets/comic/001/p04.jpg"),
      "alt": ""
    }
  })]), _vm._v(" "), _c('div', {
    attrs: {
      "data-slide": ""
    }
  }, [_c('img', {
    attrs: {
      "src": require("../assets/comic/001/p05.jpg"),
      "alt": ""
    }
  })]), _vm._v(" "), _c('div', {
    attrs: {
      "data-slide": ""
    }
  }, [_c('img', {
    attrs: {
      "src": require("../assets/comic/001/p06.jpg"),
      "alt": ""
    }
  })]), _vm._v(" "), _c('div', {
    attrs: {
      "data-slide": ""
    }
  }, [_c('img', {
    attrs: {
      "src": require("../assets/comic/001/p07.jpg"),
      "alt": ""
    }
  })]), _vm._v(" "), _c('div', {
    attrs: {
      "data-slide": ""
    }
  }, [_c('img', {
    attrs: {
      "src": require("../assets/comic/001/p08.jpg"),
      "alt": ""
    }
  })]), _vm._v(" "), _c('div', {
    attrs: {
      "data-slide": ""
    }
  }, [_c('img', {
    attrs: {
      "src": require("../assets/comic/001/p09.jpg"),
      "alt": ""
    }
  })]), _vm._v(" "), _c('div', {
    attrs: {
      "data-slide": ""
    }
  }, [_c('img', {
    attrs: {
      "src": require("../assets/comic/001/p10.jpg"),
      "alt": ""
    }
  })]), _vm._v(" "), _c('div', {
    attrs: {
      "data-slide": ""
    }
  }, [_c('img', {
    attrs: {
      "src": require("../assets/comic/001/p11.jpg"),
      "alt": ""
    }
  })]), _vm._v(" "), _c('div', {
    attrs: {
      "data-slide": ""
    }
  }, [_c('img', {
    attrs: {
      "src": require("../assets/comic/001/p12.jpg"),
      "alt": ""
    }
  })]), _vm._v(" "), _c('div', {
    attrs: {
      "data-slide": ""
    }
  }, [_c('img', {
    attrs: {
      "src": require("../assets/comic/001/p13.jpg"),
      "alt": ""
    }
  })]), _vm._v(" "), _c('div', {
    attrs: {
      "data-slide": ""
    }
  }, [_c('div', {
    staticClass: "comic-lastpage"
  }, [_c('div', {
    staticClass: "bnr"
  }, [_c('a', {
    staticClass: "bnr",
    attrs: {
      "href": "https://www.toriyasaimiso.jp/shop/",
      "target": "_blank"
    }
  }, [_c('img', {
    attrs: {
      "src": "static/assets/images/bnr_ec@sp.png",
      "alt": "東村アキコの味噌鍋革命セレクトセット"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "btn-comic-pager"
  }, [_c('a', [_vm._v("前の話")]), _vm._v(" "), _c('router-link', {
    staticClass: "active",
    attrs: {
      "to": {
        path: 'comic002'
      }
    }
  }, [_vm._v("次の話")])], 1), _vm._v(" "), _c('router-link', {
    staticClass: "btn-comic-lastpage",
    attrs: {
      "to": {
        name: '/'
      }
    }
  }, [_c('img', {
    attrs: {
      "src": require("../assets/images/btn_comic_lastpage.svg"),
      "alt": ""
    }
  })])], 1)])])], 1)])
}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('header', {
    staticClass: "comic-header"
  }, [_c('div', {
    staticClass: "logo"
  }, [_c('a', {
    attrs: {
      "href": "http://www.toriyasaimiso.jp/",
      "target": "_blank"
    }
  }, [_c('img', {
    attrs: {
      "src": require("../assets/images/logo.svg"),
      "alt": "株式会社まつや"
    }
  })])])])
}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-62ccf8c8","hasScoped":false,"transformToRequire":{"video":"src","source":"srcset","img":["src","srcset"],"image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/Comic001.vue
// module id = 113
// module chunks = 0